import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './tenantMenu.scss';
import { ORGANIZATION_CONTRACT_PANEL, ORGANIZATION_MENU_DROPDOWN, ORGANIZATION_MENU_SHOW_MORE } from 'modules/application/tenant/TenantSegmentEvents';
import { TENANT_PANEL_LINK } from './tenantMenu.component';
import { NavbarFeatures } from '../NavbarFeatures';
import { Contexts } from 'modules/core/ContextProcessorService';
import TenantMenuReactView from './TenantMenuReactView';
const TenantMenuReact = ({ $translate, SegmentService, TenantService, ContextProcessorService, BlipService, user, }) => {
    const [isTenantMenuExpanded, setTenantMenuExpanded] = useState(false);
    const [isCreateButtonsDisabledOnSharedView, setIsCreateButtonsDisabledOnSharedView] = useState(true);
    const [personalTenant, setPersonalTenant] = useState({ id: '' });
    const [currentTenant, setCurrentTenant] = useState(ContextProcessorService.context === Contexts.Default ? personalTenant : ContextProcessorService.tenant);
    const [tenants, setTenants] = useState([]);
    const [currentTenantAccountType, setCurrentTenantAccountType] = useState('');
    const [initiated, setInitiated] = useState(false);
    useEffect(() => {
        const init = async () => {
            if (initiated) {
                return;
            }
            await ContextProcessorService.waitForInitialization();
            await checkFeatures();
            const pTenant = await TenantService.getPersonalTenant();
            setPersonalTenant(pTenant);
            const tenant = ContextProcessorService.context === Contexts.Default ? personalTenant : ContextProcessorService.tenant;
            setCurrentTenant(tenant);
            personalTenant.name = pTenant.name || ContextProcessorService.tenant.name;
            if (isCreateButtonsDisabledOnSharedView && personalTenant) {
                personalTenant.name = $translate.instant('navbar.subheader.sharedWithMe');
            }
            setPersonalTenant(personalTenant);
            setTenants(await getUserTenants());
            setCurrentTenantAccountType(await getTenantCluster());
            setInitiated(true);
        };
        if (!initiated) {
            init();
        }
    }, ['initiated', 'isCreateButtonsDisabledOnSharedView']);
    const checkFeatures = async () => {
        setIsCreateButtonsDisabledOnSharedView(await NavbarFeatures.isCreateButtonsOnSharedViewDisabled());
    };
    const getUserTenants = async () => {
        try {
            BlipService.waitForInitialization();
            const tenantsResp = await TenantService.mine();
            const userTenants = [...tenantsResp.items.reverse()];
            if (personalTenant) {
                userTenants.unshift(personalTenant);
            }
            const orderedTenants = orderTenants(userTenants);
            return orderedTenants.filter(t => t.id !== currentTenant.id);
        }
        catch (e) {
            console.error(e);
            return [];
        }
    };
    const orderTenants = (tenants) => {
        const lastUsedTenantsExtra = user.extras && user.extras.lastUsedTenants || '[]';
        const lastUsedTenants = JSON.parse(lastUsedTenantsExtra);
        return tenants.sort((a, b) => lastUsedTenants.indexOf(b.id) - lastUsedTenants.indexOf(a.id));
    };
    const getTenantCluster = async () => {
        return TenantService.getTenantPlan(currentTenant.id);
    };
    const setOpenMenu = () => {
        const e = document.getElementById('menuContract');
        e.open = !e.open;
        handleOnMenuOpen();
    };
    const handleOnMenuOpen = async () => {
        setTenantMenuExpanded(tenants && tenants.length <= 3);
        SegmentService.createOrganizationTrack(ORGANIZATION_MENU_DROPDOWN);
    };
    const onOpenTenantPanel = () => {
        SegmentService.createOrganizationTrack(ORGANIZATION_CONTRACT_PANEL, {
            status: 'success',
            tab: 'overview',
        });
        window.location.href = TENANT_PANEL_LINK;
    };
    const showMoreTenants = (eventHandler) => {
        SegmentService.createOrganizationTrack(ORGANIZATION_MENU_SHOW_MORE);
        eventHandler.stopPropagation();
        setTenantMenuExpanded(true);
    };
    if (!initiated) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(TenantMenuReactView, { tenants: tenants, isTenantMenuExpanded: isTenantMenuExpanded, setOpenMenu: setOpenMenu, currentTenant: currentTenant, user: user, currentTenantAccountType: currentTenantAccountType, onOpenTenantPanel: onOpenTenantPanel, "$translate": $translate, TenantService: TenantService, SegmentService: SegmentService, showMoreTenants: showMoreTenants }));
};
export default TenantMenuReact;
